export const POST_GET_ALL = 'POST_GET_ALL'
export const POST_GET_ALL_SUCCESS = 'POST_GET_ALL_SUCCESS'
export const POST_GET_ALL_ERROR = 'POST_GET_ALL_ERROR'
export const POST_GET = 'POST_GET'
export const POST_GET_SUCCESS = 'POST_GET_SUCCESS'
export const CREATE_POST = 'CREATE_POST'
export const POST_UPDATE = 'POST_UPDATE'
export const POST_REMOVE = 'POST_REMOVE'
